export default __webpack_public_path__ + "static/media/remove.1e4d1760.png";